import React, { useEffect, useState } from 'react'
import { useIsFocused } from '@react-navigation/native';

const useInfiniteScroll = (getData) => {
    const [data, setData] = useState(null)
    const [isRefreshing, setIsRefreshing] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [currentPageNumber, setCurrentPageNumber] = useState(1)
    const [isEndOfStream, setIsEndOfStream] = useState(false)
    const isFocused = useIsFocused();
    const mutate = () => { setData([...data]) }

    const getPageInternal = async (pageNumber) => {
        setIsLoading(true)
        const newPage = await getData(pageNumber)

        if (newPage && newPage.length > 0) {
            if (!data || pageNumber === 1) {
                // the first page!
                setData(newPage)
            } else {
                setData([...data, ...newPage])
            }
        } else {
            setIsEndOfStream(true)
        }
        setCurrentPageNumber(pageNumber + 1)
        setIsLoading(false)
    }

    const onScrollPage = async () => {
        if (!isLoading && !isEndOfStream) {
            await getPageInternal(currentPageNumber)
        }
    }

    const getPageOne = async () => {
        console.log('useInfiniteScroll', 'loading page 1')
        // load page 1
        setIsRefreshing(true)
        await getPageInternal(1)
        setIsRefreshing(false)
    }
    const onRefresh = getPageOne

    useEffect(() => {
        if (isFocused) {
            getPageOne()
        }
    }, [isFocused])

    return [data, onScrollPage, onRefresh, isRefreshing, isLoading, mutate]
}

export default useInfiniteScroll